import(/* webpackMode: "eager" */ "/app/src/app/(marketing)/about/page.tsx");
